
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';  // إضافة useNavigate
import { Link } from 'react-router-dom'; // في أول الصفحة


function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [role, setRole] = useState('Participant'); // Default Role
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate(); // تعريف navigate للتوجيه

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('https://localhost:7136/register', {
        email,
        password,
        fullName,
        role,
      });

      if (res.status === 200) {
        alert('تم التسجيل بنجاح!');
        navigate('/login');  // التوجيه إلى صفحة تسجيل الدخول
      }
    } catch (err) {
      setErrorMsg('فشل التسجيل. تأكد من البيانات.');
    }
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-4"
      style={{ backgroundImage: `url('./images/photo1.jpg')` }}
    >
      <div className="bg-white bg-opacity-30 backdrop-blur-md p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">إنشاء حساب</h2>

        {errorMsg && <p className="text-red-500 text-sm text-center mb-3">{errorMsg}</p>}

        <form onSubmit={handleRegister} className="space-y-4">
          <input
            type="text"
            placeholder="الاسم الكامل"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
            required
          />
          <input
            type="email"
            placeholder="البريد الإلكتروني"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
            required
          />
          <input
            type="password"
            placeholder="كلمة المرور"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
            required
          />
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          >
            <option value="Participant">مشارك</option>
            <option value="Organizer">منظم</option>
          </select>
          <button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white p-3 rounded-xl transition"
          >
            تسجيل
          </button>
        </form>

        <div className="mt-4 text-center">
          <p className="text-gray-700">
            لديك حساب بالفعل؟{' '}
            {/* <a href="/login" className="text-purple-600 hover:text-purple-700 font-semibold">
              تسجيل الدخول
            </a> */}

<Link to="/login" className="text-purple-600 hover:text-purple-700 font-semibold">
  تسجيل الدخول
</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
